import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core'
import { CentricTypography } from '@core/component/CentricTypography'
import { getEnhancedViews } from './EnhancedViewSelectorOptions'
import { stores } from '@stores'

const useStyles = makeStyles(theme => ({
  rowWrapper: {
    height: 40,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  textStyle: {
    paddingLeft: 10
  }
}))

const EnhancedViewSelector: React.FC<any> = ({ setView, setViewSelectorPopupState }) => {
  return useObserver(function useHook() {
    const { t } = useTranslation()
    const classes = useStyles()
    const {
      nav: {
        queryParams: { clientType, orderType }
      }
    } = stores
    const listItems = getEnhancedViews(clientType, orderType)
    return (
      <div>
        {listItems.map(view => {
          return (
            <div
              className={classes.rowWrapper}
              key={view.subSection ?? view.id}
              onClick={() => {
                setView(view?.id, view?.subSection)
                setViewSelectorPopupState(false)
              }}
            >
              <view.icon />
              <CentricTypography variant='captionDarkGrey' className={classes.textStyle}>
                {t(view?.name?.key, view?.name?.default)}
              </CentricTypography>
            </div>
          )
        })}
      </div>
    )
  })
}

export default EnhancedViewSelector
